interface ReportStatus {
  id: string;
  isPolling: boolean;
}

export const ReportStorage = {
  getKey: (reportType: string) => `report_status_${reportType}`,

  set: (reportType: string, status: ReportStatus) => {
    localStorage.setItem(ReportStorage.getKey(reportType), JSON.stringify(status));
  },

  get: (reportType: string): ReportStatus | null => {
    const item = localStorage.getItem(ReportStorage.getKey(reportType));
    return item ? JSON.parse(item) : null;
  },

  remove: (reportType: string) => {
    localStorage.removeItem(ReportStorage.getKey(reportType));
  },
};
